/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

const RoleHelpText = () => {
    return (<a target="_blank" rel="noreferrer" style={{ color: "rgb(0, 157, 224)" }} href="https://wiki.viasat.com/x/V6R5Rw">About roles</a>)
}
export default RoleHelpText;